<template>
    <div class="businessListBox">
        <div class="businessList">
            <el-card class="elCard" style="padding-bottom:30px;">
                <div slot="header" class="clearfix"> 
                    <span style="color:#1AB394;font-size:18px;font-weight:500;">营业设置</span>
                </div>
                <div class="conten">
                    <div class="detail-item">
                        <span class="detail-item-label">联系人：</span>
                        <span class="detail-item-value">{{data.contant==null?'暂无':data.contant}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-item-label">联系电话：</span>
                        <span class="detail-item-value">{{data.contantMobile || "暂无"}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-item-label">门面logo：</span>
                        <p class="detail-item-value" :class="{ 'logo-img': data.shopLogo }">
                            <img :src="data.shopLogo" alt="#" v-if="data.shopLogo">
                            <template v-else>暂无</template>
                        </p>
                    </div>
                    <div class="detail-item">
                        <span class="detail-item-label">服务商简介：</span>
                        <p class="detail-item-value" >{{ data.shopIntro || "暂无" }}</p>
                    </div>
                </div>
            </el-card>
            <div class="footer-btn" v-if="$_auth('shop_all') && projectId">
                <el-button class="btnNew btnSize btn" @click="updateMsg">更新信息</el-button>
            </div>
            <!-- 弹窗 -->
            <div>
                <el-dialog 
                    :title="dialogtitle"
                    :visible.sync="newAddUserModel"
                    width="650px" height="366px"
                    class="yd-operate-model new-model"
                >
                    <div class="warp">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                            <el-form-item label="联系人" prop="name">
                                <el-input v-model="ruleForm.name" clearable placeholder="请输入联系人"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人电话" prop="phone">
                                <el-input v-model="ruleForm.phone" clearable placeholder="请输入电话"></el-input>
                            </el-form-item>
                            <el-form-item label="门店logo" prop="mainImg" ref="form_upload">
                                <el-upload
                                    :limit="1"
                                    :file-list="fileList"
                                    list-type="picture-card"
                                    name="uploadFile"
                                    :action="UpImgUri"
                                    :headers="myHeaders"
                                    :class="{hideUpload:hideUpload}"
                                    :before-upload="beforeAvatarUpload"
                                    :on-success="successUpload"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="#">
                                </el-dialog>
                            </el-form-item>
                            <el-form-item label="服务商简介" prop="shopIntro">
                                <el-input v-model="ruleForm.shopIntro" placeholder="请输入服务商简介" class="textarea_show-word-limit" :autosize="{ minRows: 6 }" clearable type="textarea" maxlength="500" show-word-limit></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class='closeBtn' style="width:100px" @click="resetForm('ruleForm')">取 消</el-button>
                        <el-button class="btnNew" @click="submitForm('ruleForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/fetch/api' 
import { GetInfo } from '@/fetch/com'
let token = GetInfo("token");
let UpImgUri = API.constantString();
import * as access from "@/config/access";
export default {
    data(){
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('联系人电话不能为空'));
            } else {
                const reg = /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3578]\d{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{3})-(\d{4}$))|(^(400)(\d{3})(\d{4}$))|(^(400[0-9])-(\d{3})-(\d{3}$))/
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的联系人电话'));
                }
            }
        };
        return {
            myHeaders: {Authorization: 'Bearer ' + token}, //上传图片的请求头
            UpImgUri,
            dialogtitle:'营业设置',
            id:'',
            newAddUserModel:false,
            dialogImageUrl: '',
            dialogVisible: false,
            hideUpload: false,
            flag:false,
            projectId: access.storage('projectId'),
            data:'',
            fileList: [],
            ruleForm:{
                name:'',
                phone:'',
                mainImg:'',
                shopIntro: ""
            },
            rules:{
                name: [
                    { required: true, message: '请输入联系人名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, validator: checkPhone, trigger: 'blur' }
                ],
                mainImg: [
                    { required: true, message: '请上传图片',trigger: 'change' }
                ],
                shopIntro: [
                    { required: true, message: '请输入服务商简介', trigger: 'blur' },
                ],
            },
        }
    },
    mounted () {
        this.getDetail ()
    },
    methods: {
        // 上传
        updateMsg () {
            this.newAddUserModel = true
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            if(this.flag){
                this.ruleForm.name = ''
                this.ruleForm.phone = ''
                this.ruleForm.mainImg==''
                this.hideUpload = false
                if(this.ruleForm.mainImg){
                    this.hideUpload = true
                }
            }else{
                this.ruleForm.name = this.data.contant
                this.ruleForm.phone = this.data.contantMobile
                this.ruleForm.shopIntro = this.data.shopIntro
                if(this.ruleForm.mainImg==''&&!this.data.shopLogo){
                    this.hideUpload = false
                }else{
                    this.fileList = []
                    if(this.data.shopLogo){
                        this.fileList.push(
                        {
                        namr:'',
                        url:this.data.shopLogo
                        }
                        )
                        this.ruleForm.mainImg = this.data.shopLogo
                        this.hideUpload = true
                    }else{
                        this.hideUpload = true
                    }
                }
            }
            
        },
        successUpload(response, file, fileList){
            for (var i in response.data) {
                var item = new Object();
                item.url = response.data[i];
            }
            this.ruleForm.mainImg = item.url
            this.hideUpload = true
		},
        handleRemove(file, fileList) {
            this.ruleForm.mainImg = ''
            this.hideUpload = false
        },
        beforeAvatarUpload(file) {//上传文件之前的钩子
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024  < 501;
            if (!isJPG && !isPNG && !isBMP) {
                this.$notify.error('请正确上传图片!');
            }
            if (!isLt2M) {
                this.$notify.error('上传图片大小不能超过 500kb!');
            }
            return (isJPG || isPNG || isBMP) && isLt2M;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 获取初始化数据
        getDetail () {
            API.http({
                    fullUrl: '/merchant/shop/enterpriseinfo',
                    type:'POST',
                    params:{
                        parkId:this.projectId
                    }
                }).then(res=>{
                    if(res.code==200){
                        if(res.data.id){
                            this.data = res.data
                            if(res.data.shopLogo){
                                this.ruleForm.mainImg = res.data.shopLogo
                            }else{
                                this.ruleForm.mainImg = ''
                            }
                            this.id = res.data.id
                        }else{
                            this.id = ''
                            this.data = {
                                contant:null,
                                contantMobile:null,
                                shopLogo:null
                            }
                            this.flag = true
                        }
                        
                    }
                })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                API.http({
                    fullUrl: '/merchant/shop/modifyenterprise',
                    type:'POST',
                    params:{
                        parkId: this.projectId,
                        contant:this.ruleForm.name,
                        contantMobile:this.ruleForm.phone,
                        shopLogo:this.ruleForm.mainImg,
                        shopIntro: this.ruleForm.shopIntro,
                        id:this.id
                    }
                }).then(res=>{
                    if(res.code==200){
                        this.flag = false
                        this.getDetail ()
                        this.newAddUserModel = false
                        this.$showAlert(res.message)
                        return
                    }
                    this.$showAlert(res.message, "error")
                })
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.newAddUserModel = false
            this.fileList = []
        }
    }
}
</script>
<style lang="scss" scoped>
    .businessListBox{
        height: 100%;
        .businessList{
            background-color: #fff;
            border-radius: 4px;
            .conten{
                margin-top: 10px;
                margin-left:250px;
                position: relative;
                padding-right: 40px;
                .detail-item{
                    display: flex;
                    align-items: flex-start;
                    margin-top: 15px;
                    font-size: 14px;
                    .detail-item-label{
                        width: 96px;
                        text-align: right;
                        line-height: 22px;
                    }
                    .detail-item-value{
                        flex: 1;
                        margin-left: 20px;
                        word-break: break-all;
                        line-height: 22px;
                        &.logo-img{
                            img{
                                width: 100px;
                                height: 100px;
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }
            .footer-btn{
                width: 100%;
                width:calc(100% - 220px);
                position: fixed;
                bottom:0;
                background-color: #fff;
                margin-left: -20px;
                height: 60px;
                line-height: 60px;
                text-align: center;
            }
        }
    }   
</style>
<style lang="scss">
.businessList{
    .el-upload-list__item{
        transition: none;
    }
    .el-card__header{
        padding: 8px 20px;
    }
    .el-textarea__inner{
        width: 100%;
    }
    .el-upload--picture-card {
            background-color: #fbfdff;
            border:1px dashed #c0ccda;
            border-radius:6px;
            box-sizing:border-box;
            width:100px;
            height:100px;
            line-height:98px;
            vertical-align: top;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100px;
            height: 100px;
            margin: 0 8px 8px 0;
            display: inline-block;
        }
        .hideUpload .el-upload--picture-card {
            display: none;
        }
}
 
</style>
